export const Panels = {
  shared: { SEARCH: "SEARCH", ANNOTATIONS: "ANNOTATIONS", RELATED: "RELATED" },
  viewer: { VIEWS: "VIEWS" },
  transcript: {},
  audio: {},
};
